import { api } from "@/lib/api";

export async function downloadRca(rcaId, fmt) {
  const res = await api.get(`/om/rca/${rcaId}/export/${fmt}`, { responseType: "blob" });
  const name = (res.headers["content-disposition"] || "").match(/filename="?([^"]+)"?/)?.[1] || `PlanSarthi_RCA.${fmt}`;
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  return name;
}
